import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { fuseAnimations } from "@fuse/animations";
import { GameCategory } from "@lbsdk/*";
import { DateFormatPipe } from "angular2-moment";
import { FuseSplashScreenService } from "@fuse/services/splash-screen.service";
import * as moment from "moment";
import { GameService } from "@app/main/content/game/game.service";
import { fromEvent, Subject } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { takeUntil } from "rxjs/internal/operators";
import { Router } from "@angular/router";
import { GameApi } from "@app/shared/sdk/services/custom/Game";

@Component({
  selector: "app-game",
  templateUrl: "./game.component.html",
  styleUrls: ["./game.component.scss"],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
  providers: [DateFormatPipe],
})
export class GameComponent implements OnInit, OnDestroy {
  currentGames: any[] = [];
  endedGames: any[] = [];
  currentCategory = "all";
  gameCategories: any[] = [];
  categories: GameCategory[] = [];
  p = 1;
  page = 1;
  @ViewChild("filter")
  filter: ElementRef;

  noOfGames: number = 0;
  gameType: string = "endedGames";

  // Private
  private _unsubscribeAll: Subject<any>;
  queryParams: any;

  constructor(
    private gameApi: GameApi,
    public dfp: DateFormatPipe,
    private router: Router,
    private fuseSplashScreen: FuseSplashScreenService,
    public gamesService: GameService
  ) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  ngOnInit() {
    this.categories = this.gamesService.categories;

    this.getDuplicateGames();

    // this.getGames(1, "currentGames", {
    //   drawDate: { gte: moment().toJSON() },
    // });

    fromEvent(this.filter.nativeElement, "keyup")
      .pipe(
        takeUntil(this._unsubscribeAll),
        debounceTime(150),
        distinctUntilChanged()
      )
      .subscribe(async () => {
        if (!this.currentGames || !this.endedGames) {
          return;
        }
        
        const filterValue = this.filter.nativeElement.value.trim();
        const currentDate = moment().toJSON();
        
        if (filterValue !== "") {
          try {
            const games: any = await this.gameApi.find({
              where: {
                title: { like: filterValue, options: "i" },
              },
              include: ["players", "category", "prizes"],
            }).toPromise();
        
            if (!games || games.length === 0) {
              return;
            }
        
            for (let i = 0; i < games.length; i++) {
              games[i].isTab = "info";
              games[i].isCountDown = games[i].sharingContentCountdown !== "";
              games[i].isPulsate = false;
            }
        
            this.currentGames = games.filter((game: any) => game.drawDate >= currentDate);
            this.endedGames = games.filter((game: any) => game.drawDate <= currentDate);
          } catch (error) {
            console.error("An error occurred while fetching games:", error);
            throw error;
          }
        } else {
          this.getGames(1, "currentGames", {
            drawDate: { gte: currentDate },
          });
          this.getGames(1, "endedGames", {
            drawDate: { lte: currentDate },
          });
        }        
      });
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  routeToNewGamePage() {
    localStorage.setItem("newGameFlag", JSON.stringify(true));
    this.router.navigate(["/game/new"]);
  }

  filterByCategory = async (choice) => {
    this.fuseSplashScreen.show();
    if (choice === "all") {
      this.getGames(1, "currentGames", {
        drawDate: { gte: moment().toJSON() },
      });
      this.getGames(1, "endedGames", {
        drawDate: { lte: moment().toJSON() },
      });
    } else {
      if (choice) {
        try {
          let games: any[] = await this.gameApi
            .find({
              where: { categoryId: choice },
              include: ["players", "category", "prizes"],
            })
            .toPromise();

          this.fuseSplashScreen.hide();
          if (!games || games.length === 0) {
            return;
          }

          for (let i = 0; i < games.length; i++) {
            games[i].isTab = "info";
            games[i].isCountDown = games[i].sharingContentCountdown !== "";
            games[i].isPulsate = false;
          }

          this.currentGames = games.filter(
            (game: any) => game.drawDate >= moment().toJSON()
          );

          this.endedGames = games.filter(
            (game: any) => game.drawDate <= moment().toJSON()
          );
        } catch (error) {
          this.fuseSplashScreen.hide();
          return;
        }
      } else {
        // No Game
        this.currentGames.length = 0;
        this.endedGames.length = 0;
        this.fuseSplashScreen.hide();
      }
    }
  };

  getGames = async (page: number, tab, filter) => {
    this.page = page;
    const limit = 6;
    const skip = (page - 1) * limit;

    filter = this.gameType === undefined || this.gameType === 'currentGames' ? {
      drawDate: { gte: moment().toJSON() }
    } : filter;

    try {
      this.fuseSplashScreen.show();
      let games: any[] = await this.gamesService
        .getGames(skip, limit, filter)
        .toPromise();

      this.fuseSplashScreen.hide();
      if (!games || games.length === 0) return;

      for (let i = 0; i < games.length; i++) {
        games[i].isTab = "info";
        games[i].isCountDown = games[i].sharingContentCountdown !== null;
        games[i].isPulsate = false;
      }
      this[tab] = [...games];
      await this.gettingGamesCount();
    } catch (error) {
      this.fuseSplashScreen.hide();
      console.log("error....", error);
      throw error;
    }
  };

  gettingGamesCount = async () => {
    const countFilter = this.gameType === 'currentGames' ? { drawDate: { gte: moment().toJSON() } } : {
      drawDate: { lte: moment().toJSON() },
    };
    const countResponse = await this.gameApi.count(countFilter).toPromise();

    if (!countResponse) throw new Error("Cannot Get Games Count");

    if (this.gameType === 'currentGames')
      this.noOfGames = countResponse.count;
  }

  matTabChange = async ($event) => {
    if ($event && $event.index === 0) {
      this.currentGames = [];
      this.gameType = "currentGames";
      this.noOfGames = this.gamesService.currentNoOfGames;
      await this.getGames(1, "currentGames", {
        drawDate: { gte: moment().toJSON() },
      });
      
    } else {
      this.endedGames = [];
      this.gameType = "endedGames";
      await this.getDuplicateGames();
    }
  }

  getDuplicateGames = async (limit?, skip?) => {
    if (this.gameType === 'endedGames') {
      try {
        this.fuseSplashScreen.show();
        let response: any = await this.gameApi.gamesWithDuplicateData(6, 0).toPromise();
        if (!response && response.totalGames === 0) {
          this.fuseSplashScreen.hide();
          return;
        }
        for (let i = 0; i < response.games.length; i++) {
          response.games[i].isTab = "info";
          response.games[i].isCountDown = response.games[i].sharingContentCountdown !== null;
          response.games[i].isPulsate = false;
        }
        this['endedGames'] = [...response.games];
        this.noOfGames = response.totalGames;
        this.fuseSplashScreen.hide();
      } catch (error) {
        this.fuseSplashScreen.hide();
        throw error;
      }
    }
  } 
}
